/** @jsx jsx */
import { jsx } from '@emotion/core'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react'
import SimpleBettingHistory from '@components/SimpleBettingHistory'
import { formatCreatedAtToElapsedTime, makeAttachmentDetailObjToBettingRecordTrack } from '@utils/utils'
import { Schema$ChatMessage } from '@interface/chat'
import { UserPickSpecialMemberMark } from '@views/Home/UserPick/Components/UserPickSpecialMemberMark'
import styled from '@themes/theme'
import { ProfileImgWrapStyle } from '@views/Popup/Chat/index.style'
import SharedBettingListPopup from '@views/Popup/Chat/SharedBettingListPopup'
import useRootStore from '@store/useRootStore'
import * as _ from 'lodash'
import AdvImg from '@components/AdvImg'

interface UserShareBettingHistoryItemProps {
  chatMessage: Schema$ChatMessage
}

const ShareBettingHistoryWrap = styled.div`
    background: ${props => props.theme.color.modalBg};

    .share-betting-history-list {
        width: calc(100% - 33px);
        margin: 0 auto;
        padding: 16px 0;
        border-bottom: 1px solid ${props => props.theme.color.modalSubBg2};
        display: flex;
        flex-wrap: nowrap;

        .user-profile {
            width: 40px;
            height: 40px;
            position: relative;

            .profile-img-wrap {
                ${ProfileImgWrapStyle};
            }

            .mark {
                position: absolute;
                top: 25px;
                left: 25px;
            }
        }

        .contents {
            position: relative;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
            margin-left: 12px;

            .contents-info {
                width: 100%;
                display: flex;
                justify-content: space-between;
                margin-bottom: 5px;

                .nick-info {
                    font-size: ${props => props.theme.font.medium};
                    font-weight: ${props => props.theme.fontW.bold};
                    color: ${props => props.theme.color.modalTxt};
                }

                .date {
                    margin: 0 10px 0 auto;
                    font-size: ${props => props.theme.font.medium};
                    font-weight: ${props => props.theme.fontW.medium};
                    color: ${props => props.theme.color.modalgray};
                }
            }

            .chat-bubble {
                display: flex;
                flex-wrap: wrap;
                flex-flow: column;
                align-items: flex-start;
                background: ${props => props.theme.color.modalSubBg2};
                width: auto;
                max-width: calc(100% - 36px);
                height: auto;
                padding: 7px 10px;
                border-radius: 0 10px 10px 10px;

                &-txt {
                    word-break: break-word;
                    white-space: pre-wrap;
                    line-height: 1.8rem;
                    text-align: left;
                    width: 100%;
                    font-size: ${props => props.theme.font.medium};
                    font-weight: ${props => props.theme.fontW.medium};
                    color: ${props => props.theme.color.modalTxt};
                }
            }
        }

        &:first-of-type {
            padding-top: 22px;
        }
    }
`

export const UserShareBettingHistoryItem: React.FC<UserShareBettingHistoryItemProps> = observer((props) => {
  const { chatMessage } = props
  const { globalStore, authStore } = useRootStore()
  const { attachmentDetail } = chatMessage
  const { userInfo } = authStore

  const attachmentDetailObj = attachmentDetail ? JSON.parse(attachmentDetail) as any : undefined

  const onClickOpenBettingListInfo = () => {
    const popupTit = (
      <Fragment>
        <span className="am-modal-title--point--blue">{userInfo.nick}</span>님의 공유 내역
      </Fragment>
    )
    globalStore.pushDialogOk({
      iconTitle: popupTit,
      custom: <SharedBettingListPopup bettorBetId={attachmentDetailObj.bettorBetId}/>,
      className: 'big-size box-type icon-tit share-betting-popup',
      singlePress: '확인',
      callbackCloseDialog: () => {
        globalStore.closeDialog()
      },
      // 뒷배경 클릭 시 닫히도록
      callbackCloseDialogBg: () => {
        globalStore.closeDialog()
      },
    })
  }

  return (
    <ShareBettingHistoryWrap>
      <div key={chatMessage.id} className="share-betting-history-list">
        <div className="user-profile">
          <div className="profile-img-wrap lhn33">
            <AdvImg src={chatMessage.fromUserProfileImg} srcMode={'small'} alt="스킨 프로필" className="profile-img"/>
          </div>
          <UserPickSpecialMemberMark
            showSMark={userInfo.isSpecialMember} small lightBorder
            isSpecialMember={!_.isNil(userInfo.sMemberMark)}
            userTitleId={userInfo.userTitleId}
            userTitleEnabled={userInfo.userTitleEnabled}
          />
        </div>

        <div className="contents">
          <div className="contents-info">
            <p className="nick-info">{chatMessage.fromUserNick}</p>
            <p className="date">{formatCreatedAtToElapsedTime({ createdAt: chatMessage.createdAt })}</p>
          </div>
          <div className="chat-bubble">
            <SimpleBettingHistory
              bettingRecordTrack={makeAttachmentDetailObjToBettingRecordTrack(attachmentDetailObj)}
              onClickOpenBettingListInfo={onClickOpenBettingListInfo}
            />
            <p className="chat-bubble-txt">{chatMessage.contents}</p>
          </div>
        </div>
      </div>
    </ShareBettingHistoryWrap>
  )
})
